import { PropOptions, PropType } from "vue";
import { isObject, isUndefined } from "./inspect"

// Generates a prop object
export function makeProp<T>(
	type: PropType<T>,
	value?: T,
	requiredOrValidator?: boolean | ((value: T) => boolean),
	validator?: (value: T) => boolean
): PropOptions<T> {
	const required = requiredOrValidator === true;
	const notRequired = requiredOrValidator === false || requiredOrValidator === undefined;
	validator = required ? validator :
		notRequired ? undefined : requiredOrValidator;

	return {
		type,
		...(required
			? { required }
			: isUndefined(value)
				? {}
				: { default: isObject(value) ? () => value : value }),
		...(isUndefined(validator) ? {} : { validator })
	}
}
